import React from 'react';

export interface ChartLegendItem {
    label: string;
    color: string;
    variant: 'bar' | 'line';
}

interface ChartLegendPanelProps {
    title?: string;
    aside?: React.ReactNode;
    items: ChartLegendItem[];
}

const ChartLegendPanel: React.FC<ChartLegendPanelProps> = ({ title = 'Legenda', aside, items }) => {
    return (
        <aside className="management-overview-chart-legend" aria-label={title}>
            <div className="management-overview-chart-legend__header">
                <span className="management-overview-chart-legend__title">{title}</span>
                {aside ? <span className="management-overview-chart-legend__aside">{aside}</span> : null}
            </div>
            <ul className="management-overview-chart-legend__list">
                {items.map((item) => (
                    <li key={item.label} className="management-overview-chart-legend__item">
                        <span
                            className={`management-overview-chart-legend__swatch management-overview-chart-legend__swatch--${item.variant}`}
                            style={{ '--legend-color': item.color } as React.CSSProperties}
                            aria-hidden="true"
                        />
                        <span>{item.label}</span>
                    </li>
                ))}
            </ul>
        </aside>
    );
};

export default ChartLegendPanel;
